// Timezone designator required — without it `new Date(...)` parses as the
// browser's local time, silently shifting the wire value.
const ISO_DATETIME_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})$/;
// `format: date` fields ship as YYYY-MM-DD; useDates types them as Date too.
const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
// Decimal point required so zip codes / phone fragments / IDs stay strings.
const DECIMAL_RE = /^-?\d+\.\d+$/;

function coerceString(value: string): string | Date | number {
  if (ISO_DATETIME_RE.test(value) || ISO_DATE_RE.test(value)) {
    const date = new Date(value);
    if (!Number.isNaN(date.getTime())) return date;
  }
  if (DECIMAL_RE.test(value)) {
    const num = Number(value);
    if (Number.isFinite(num)) return num;
  }
  return value;
}

export function coerceWireValues(value: unknown): unknown {
  if (typeof value === "string") return coerceString(value);
  if (value === null || typeof value !== "object") return value;

  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      value[i] = coerceWireValues(value[i]);
    }
    return value;
  }

  const obj = value as Record<string, unknown>;
  for (const key of Object.keys(obj)) {
    obj[key] = coerceWireValues(obj[key]);
  }
  return obj;
}
